import React, { useState } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarInterpreter";
import Header from "components/Navbars/InterpreterNavbar";
import { AppointmentRoutes } from "views-interpreters/AppointmentList";
import routesInterpreters from "routes-interpreter";
import { useSelector } from "react-redux";

function InterpreterLayout(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();

  const { user } = useSelector((state) => state.user);
  const role = user?.user?.role;
  const internalInterpreter = user?.user?.internal_interpreter;

  const filteredRoutes = routesInterpreters.filter((route) => {
    if (route.path === "/Timesheet" && role === "staff_interpreter" && internalInterpreter === 0) {
      return false;
    }
    if (route.path === "/payments" && role === "staff_interpreter" && internalInterpreter === 1) {
      return false;
    }
    return true;
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={filteredRoutes}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {filteredRoutes.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default InterpreterLayout;
